/* eslint-disable */
import Vue from 'vue'
import Router from 'vue-router'
import store from '../store/index'
import LoginPage from '@/views/Login'
import ProductPage from '@/views/Product'
import Selector from '@/views/Selector'
// import Selector_new from '@/views/Selector_new'
import Production from '@/views/Production'
import ConflictTable from '@/components/production/N_ResolveConflictTable'
// import ConflictNewProduct from '@/components/production/N_ResolveConflictForNewProd' // a better verion of resolveConflict , not ready
import NewProduct from '@/components/production/N_NewProduct'
import ProductTable from '@/components/production/N_ProductTable'
import ProductsConfiguration from '@/components/production/N_ProductsConfiguration'
// import Import from '@/components/selector/Import.vue'
import Admin from '@/views/Admin.vue'
import SpecsMatrix from '@/views/SpecsMatrix.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '*',
      redirect: '/login',
      component: LoginPage
    },
    {
      path: '/login',
      name: 'Login',
      component: LoginPage,
      meta: { layout: 'default' }
    },
    {
      path: '/product',
      name: 'URLs',
      component: ProductPage
    },
    {
      path: '/production',
      name: 'production',
      component: Production,
      children: [
        {
          path: 'product-table',
          name: 'product-table',
          component: ProductTable,
        },
        {
          path: 'new-product',
          name: 'new-product',
          component: NewProduct,
        },
        // {
        //   path: 'conflict',
        //   name: 'conflict-new-product',
        //   component: ConflictNewProduct,
        //   props: true
        // },
        {
          path: 'conflict',
          name: 'conflict-table',
          component: ConflictTable,
          props: true
        },
        {
          path: 'products-configuration',
          name: 'products-configuration',
          component: ProductsConfiguration,
        },
      ]
    },
    {
      path: '/admin',
      name: 'Admin',
      component: Admin
    },
    // {
    //   path: '/conflict',
    //   name: 'conflict-table',
    //   component: ConflictTable
    // },
    // {
    //   path: '/new-product',
    //   name: 'new-product',
    //   component: NewProduct,
    // },
    // {
    //   path: '/import',
    //   name: 'Import',
    //   component: Import
    // },
    {
      path: '/selector',
      name: 'Selector',
      component: Selector
    },
    // {
    //   path: '/selector_new',
    //   name: 'Selector_new',
    //   component: Selector_new
    // },
    {
      path: '/specsmatrix',
      name: 'SpecsMatrix',
      component: SpecsMatrix
    },
    {
      path: '*',
      component: LoginPage
    }
  ]
})

router.beforeEach((to, from, next) => {
  const onlyWhenLoggedOut = to.matched.some(record => record.meta.layout === 'default')
  const loggedIn = store.state.authModule.authtoken
  if (!loggedIn && to.path !== '/login') {
    next('/login')
  } else if (onlyWhenLoggedOut && loggedIn) {
    next('/admin')
  } else {
    next()
  }

  if (to.name === 'product-table') {
    console.log('reset_production')
    store.commit('productionModule/RESET_PRODUCTION')
  }

  // if (this.$store.state.productionModule.products_ids_with_conflict.length = 0
  //   && from.includes('production/conflict') ) {
  //   next("/production")
  // }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js